import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-huobi",
  "use": "icon-huobi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-huobi\"><path d=\"M512 0C229.76 0 0 229.76 0 512s229.76 512 512 512 512-229.76 512-512S794.24 0 512 0z m225.92 390.4c0 24.96-19.84 44.8-44.8 44.8s-44.8-19.84-44.8-44.8v-17.92c0-55.68-45.44-100.48-100.48-100.48-55.68 0-100.48 45.44-100.48 100.48V473.6h124.16c24.96 0 44.8 19.84 44.8 44.8s-19.84 44.8-44.8 44.8H447.36v150.4h246.4c24.96 0 44.8 19.84 44.8 44.8s-19.84 44.8-44.8 44.8h-358.4c-24.96 0-44.8-19.84-44.8-44.8s19.84-44.8 44.8-44.8h22.4V563.2h-39.68c-24.96 0-44.8-19.84-44.8-44.8s19.84-44.8 44.8-44.8h39.68V372.48c0-104.96 85.12-190.08 190.08-190.08s190.08 85.12 190.08 190.08V390.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/huobi.svg
// module id = PyRl
// module chunks = 36